// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../order-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cropper[data-v-f8a365d2]{width:100%;height:auto;margin:0 auto;max-width:400px;max-height:400px}.cropper[data-v-f8a365d2]  .line-handler{border:1px solid #2c5bc5}.cropper[data-v-f8a365d2]  .cropper-handler{border:2px solid #2c5bc5;border-radius:50%}.cropper[data-v-f8a365d2]  .vue-simple-handler{width:15px;height:15px}.cropper-controls button[data-v-f8a365d2]{background:none;border:none;font-size:26px}.disabled[data-v-f8a365d2]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
